const productDisclalmers = {
    modifydisclaimeraccordation: function (disclaimerText) {
        var disclaimerBodyText = $('.declaimer-configure-tab').find('.disclaimer-tab-body-text');
        if (disclaimerText) {
            disclaimerBodyText.html(disclaimerText);
        }
    },
    setupDisclaimerCollapseEvents: function () {
        let disclaimerScrolled = false;
        $('#productConfigureDisclaimerCollapse').on('shown.bs.collapse', function () {
            if (!disclaimerScrolled) {
                document.getElementById('productConfigureDisclaimerAccordion').scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                disclaimerScrolled = true;
            }
        });
    },
    setupPageListeners: function () {
        const modifydisclaimeraccordation = this.modifydisclaimeraccordation.bind(this);
        $('body').on('product:afterAttributeSelect', function (el, response) {
            modifydisclaimeraccordation(response.data.product.customProps.disclaimerText);
        });

        $('body').on('configurator:stageUpdate:configure', function () {
            $('#productConfigureDisclaimerAccordion').removeClass('stage-summary');
        });
        $('body').on('configurator:stageUpdate:summary', function () {
            $('#productConfigureDisclaimerAccordion').addClass('stage-summary');
        });
    },
    init: function () {
        this.setupPageListeners();
    }
}

module.exports = productDisclalmers;
